import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Nashikairporttoshirdicab() {



    const cardData = {





keyword: "Nashik Airport to Shirdi Cab",

headingDescription: "Sai Shirdi Cab offers comfortable and reliable Nashik Airport to Shirdi Cab service for devotees, families, senior citizens, tourists, business travelers, and groups arriving at Nashik Airport and traveling to Shirdi. Customers can book a private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for airport pickup, hotel transfers, Sai Baba darshan, one-way journeys, round trips, and customized pilgrimage tours. With experienced drivers, clean and well-maintained vehicles, comfortable seating, sufficient luggage space, flexible pickup arrangements, and convenient door-to-door transportation, passengers can continue their journey from Nashik Airport without changing vehicles. The service is suitable for travelers arriving for Shirdi pilgrimage as well as passengers planning to combine Shirdi with nearby temples, religious destinations, heritage attractions, and Maharashtra sightseeing locations.",

topPlaces: [
  {
    title: "Shirdi",
    description: "Shirdi is the main destination for travelers arriving through Nashik Airport and is one of Maharashtra's most important pilgrimage towns. Passengers can book a private cab directly from the airport to their hotel, Sai Baba Temple area, or preferred location. Comfortable vehicles are suitable for families, senior citizens, devotees, and groups carrying luggage."
  },
  {
    title: "Sai Baba Temple",
    description: "Sai Baba Temple is the primary pilgrimage attraction in Shirdi and the main destination for many travelers booking an airport transfer. Customers can arrange direct transportation from Nashik Airport according to their arrival schedule and darshan plans. Private cabs provide convenient door-to-door travel for families and devotional groups."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and cultural city surrounding the airport region and can be included in a broader Shirdi itinerary. Travelers can visit temples, heritage attractions, and other local destinations before continuing to Shirdi. Sai Shirdi Cab offers flexible private transportation for customers planning multiple stops."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a renowned Jyotirlinga pilgrimage destination near Nashik and is an excellent addition to a Shirdi religious tour. Travelers arriving at Nashik Airport can include the temple in their itinerary before continuing toward Shirdi. Private cab service provides comfortable transportation for families and devotees planning multiple temple visits."
  },
  {
    title: "Saptashrungi Gad",
    description: "Saptashrungi Gad is a revered Shakti pilgrimage destination in the Nashik region and can be included in an extended religious journey from Nashik Airport to Shirdi. Devotees can customize their route to cover the shrine along with Shirdi and other temples. Comfortable private vehicles are suitable for families and pilgrimage groups."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a famous pilgrimage destination near Shirdi and is frequently combined with a Sai Baba temple visit. Travelers arriving through Nashik Airport can arrange a private cab covering Nashik, Shirdi, and Shani Shingnapur according to their schedule. One-way and round-trip options are available for convenient religious travel."
  },
  {
    title: "Grishneshwar",
    description: "Grishneshwar is a revered Jyotirlinga shrine and an important destination for devotees exploring Maharashtra's religious circuit. Travelers can include Grishneshwar in a customized airport-to-Shirdi pilgrimage itinerary. Private cab transportation allows families and groups to travel comfortably with luggage and make suitable sightseeing stops."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a major heritage attraction near Grishneshwar and are ideal for travelers who want to combine historical sightseeing with their Shirdi pilgrimage. Customers can include Ellora in their itinerary after arriving at Nashik Airport and before or after visiting Shirdi. A private cab provides flexibility for sightseeing and hotel transfers."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is an important heritage and commercial city with historic monuments, temples, caves, and cultural attractions. Travelers can extend their Nashik Airport to Shirdi trip into a broader Maharashtra tour by including the city. Sai Shirdi Cab provides suitable vehicles for families and groups planning multi-day travel."
  },
  {
    title: "Ahmednagar",
    description: "Ahmednagar is a significant Maharashtra city with historical, commercial, and regional importance and can be added to an extended Shirdi travel itinerary. Customers can arrange private transportation between Nashik Airport, Shirdi, and Ahmednagar based on their travel plans. The service is suitable for family visits, business travel, and sightseeing."
  },
  {
    title: "Pune",
    description: "Pune is a major business, technology, and educational destination in Maharashtra and can be included in a longer itinerary after visiting Shirdi. Travelers can arrange private cab transportation for direct travel or a multi-city journey. Sedan, Ertiga, Innova, and Innova Crysta options can be selected according to passenger and luggage requirements."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a scenic hill destination near Nashik known for mountains, valleys, waterfalls, and peaceful surroundings. Travelers arriving through Nashik Airport can combine Igatpuri with Shirdi for a religious and nature-focused tour. Private cab service provides flexible transportation for sightseeing, hotel transfers, and onward travel."
  }
],



"services": [
{
"name": "Nasik Airport to Shirdi Taxi Fare",
"description": "Nasik Airport to Shirdi Taxi Fare depends on the selected vehicle, journey type, pickup requirements, and travel schedule. Travelers can choose a suitable private cab for a comfortable airport transfer to Shirdi with options for one-way and round-trip travel."
},
{
"name": "Nasik Airport to Shirdi Taxi",
"description": "Nasik Airport to Shirdi Taxi provides convenient private transportation for passengers arriving at Nashik Airport and traveling to Shirdi. Cab pickup can be coordinated with the arrival schedule, with suitable vehicles available for individuals, families, and groups."
},
{
"name": "Nasik Airport Shirdi Taxi Fare",
"description": "Nasik Airport Shirdi Taxi Fare can vary according to the vehicle category, number of passengers, trip duration, and selected travel plan. Customers can choose from different cab options based on luggage capacity and whether the journey is one-way or round trip."
},
{
"name": "Best Taxi from Nasik Airport to Shirdi",
"description": "Best Taxi from Nasik Airport to Shirdi offers a practical travel solution for passengers looking for comfortable airport-to-Shirdi transportation. Private cabs can be arranged with convenient pickup, direct travel, and vehicle choices suitable for different passenger requirements."
},
{
"name": "Cheap Taxi Nasik Airport Shirdi",
"description": "Cheap Taxi Nasik Airport Shirdi provides a budget-friendly option for travelers seeking private transportation without choosing public transport. Customers can select an appropriate vehicle for direct airport transfers, family travel, and planned journeys to Shirdi."
},
{
"name": "Book Taxi Nasik Airport to Shirdi",
"description": "Book Taxi Nasik Airport to Shirdi makes it convenient for travelers to arrange their airport transfer in advance. Cab bookings can be planned according to flight arrival time, passenger count, luggage, preferred vehicle, and required drop-off location in Shirdi."
},
{
"name": "One-Way Taxi Nasik Airport Shirdi",
"description": "One-Way Taxi Nasik Airport Shirdi is suitable for passengers who only require transportation from Nashik Airport to Shirdi. Private cab service provides direct travel with vehicle options selected according to the number of passengers and luggage requirements."
},
{
"name": "Round Trip Taxi Nasik Airport Shirdi",
"description": "Round Trip Taxi Nasik Airport Shirdi is useful for travelers planning airport transfers along with a return journey. The cab arrangement can be organized around the travel itinerary, Shirdi stay, sightseeing plans, and preferred return schedule."
},
{
"name": "Car Rental Nasik Airport to Shirdi",
"description": "Car Rental Nasik Airport to Shirdi provides private vehicle options for travelers who prefer a comfortable journey from the airport. Cars can be arranged for direct transfers, family travel, sightseeing requirements, and return trips based on the selected itinerary."
},
{
"name": "Reliable Taxi Nasik Airport Shirdi",
"description": "Reliable Taxi Nasik Airport Shirdi provides a convenient option for passengers requiring planned transportation after arriving at the airport. Cab service can be scheduled around flight timings and arranged with suitable vehicles for individuals, families, and groups."
},
{
"name": "Distance Nasik Airport Shirdi Taxi",
"description": "Distance Nasik Airport Shirdi Taxi is a useful search for travelers planning their airport-to-Shirdi journey and estimating travel requirements. Private cab service can be arranged for direct transportation with the vehicle category selected according to passenger and luggage needs."
},
{
"name": "Nasik Airport to Shirdi Innova Taxi",
"description": "Nasik Airport to Shirdi Innova Taxi provides a spacious travel option for families and groups arriving at Nashik Airport. An Innova can be arranged for comfortable airport pickup, luggage transportation, direct travel to Shirdi, and return or onward journeys."
},
{
"name": "Nashik Airport to Shirdi Ertiga Cabs",
"description": "Nashik Airport to Shirdi Ertiga Cabs offer a practical option for passengers looking for a spacious vehicle for airport transportation. Ertiga cab service can accommodate families and small groups with luggage while providing direct travel from the airport to Shirdi."
},
{
"name": "Ozar Airport to Shirdi Taxi Service",
"description": "Ozar Airport to Shirdi Taxi Service provides private transportation for passengers traveling from Ozar Airport toward Shirdi. Cab pickup can be planned according to the arrival schedule, with vehicle options available for individual travelers, families, and groups."
},
{
"name": "Nasik Airport to Shirdi Sedan Cab",
"description": "Nasik Airport to Shirdi Sedan Cab provides a comfortable option for individuals and small families traveling from the airport to Shirdi. Sedan vehicles can be arranged for direct airport transfers, with convenient pickup and drop-off based on the passenger's travel schedule."
}
],
"tableData": [
["Nasik Airport to Shirdi Taxi Fare", "Nasik Airport to Shirdi Taxi"],
["Nasik Airport Shirdi Taxi Fare", "Best Taxi from Nasik Airport to Shirdi"],
["Cheap Taxi Nasik Airport Shirdi", "Book Taxi Nasik Airport to Shirdi"],
["One-Way Taxi Nasik Airport Shirdi", "Round Trip Taxi Nasik Airport Shirdi"],
["Car Rental Nasik Airport to Shirdi", "Reliable Taxi Nasik Airport Shirdi"],
["Distance Nasik Airport Shirdi Taxi", "Nasik Airport to Shirdi Innova Taxi"],
["Nashik Airport to Shirdi Ertiga Cabs", "Ozar Airport to Shirdi Taxi Service"],
["Nasik Airport to Shirdi Sedan Cab", "Nasik Airport to Shirdi Taxi"]
],














        whychoose: [
            { 
                WhyChooseheading: "Nashik Airport to Shirdi Cab for Pilgrimage Transfers", 
                WhyChoosedescription: "Sai Shirdi Cabs offers private taxi transportation from Nashik Airport to Shirdi for devotees, families, tourists, senior citizens, and business travellers. A dedicated cab provides direct airport-to-Shirdi travel with space for passengers and their luggage." 
            }, 
            { 
                WhyChooseheading: "Airport Pickup Based on Your Flight Schedule", 
                WhyChoosedescription: "Share your Nashik Airport arrival details while booking so the pickup can be planned around your flight schedule. Passengers can continue towards Shirdi after landing without arranging separate local transportation." 
            }, 
            { 
                WhyChooseheading: "Direct Travel Towards Sai Baba Temple", 
                WhyChoosedescription: "Devotees arriving at Nashik Airport can travel directly towards Shirdi and their preferred hotel or destination near Sai Baba Temple. The private transfer avoids the inconvenience of changing vehicles during the journey." 
            }, 
            { 
                WhyChooseheading: "Comfortable Option for Family Pilgrimages", 
                WhyChoosedescription: "Families travelling with children, senior citizens, and pilgrimage luggage can select a suitable cab according to their group size. Having a dedicated vehicle allows everyone to travel together from the airport to Shirdi." 
            }, 
            { 
                WhyChooseheading: "Useful for Sai Baba Darshan Planning", 
                WhyChoosedescription: "Travellers can coordinate their airport arrival and Shirdi visit around their Darshan plans. A private cab provides flexibility to continue towards the pilgrimage destination after completing the airport transfer." 
            }, 
            { 
                WhyChooseheading: "One-Way Airport Drop to Shirdi", 
                WhyChoosedescription: "Passengers who only require transportation from Nashik Airport to Shirdi can choose a one-way cab. This is suitable when separate arrangements have already been made for local travel or the return journey." 
            }, 
            { 
                WhyChooseheading: "Vehicle Options for Different Group Sizes", 
                WhyChoosedescription: "Cab options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage quantity, and preferred comfort level for the airport transfer." 
            }, 
            { 
                WhyChooseheading: "Book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs", 
                WhyChoosedescription: "Provide your Nashik Airport arrival details, pickup information, Shirdi destination, travel date, passenger count, luggage requirements, and preferred vehicle to Sai Shirdi Cabs for a suitable private airport cab arrangement." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a cab from Nashik Airport to Shirdi?", 
            answer: "Yes, Sai Shirdi Cabs provides private cab services from Nashik Airport to Shirdi for devotees, families, tourists, senior citizens, and other travellers." 
        }, 
        { 
            question: "Can I get pickup from Nashik Airport after my flight arrives?", 
            answer: "Yes, passengers can arrange airport pickup by sharing their flight details and expected arrival information during the booking process." 
        }, 
        { 
            question: "Can I travel directly from Nashik Airport to Shirdi?", 
            answer: "Yes, a private cab provides direct transportation from Nashik Airport to Shirdi, allowing passengers to continue their journey without arranging multiple connecting vehicles." 
        }, 
        { 
            question: "Is Nashik Airport to Shirdi Cab suitable for Sai Baba Darshan?", 
            answer: "Yes, the service is suitable for devotees arriving at Nashik Airport and travelling to Shirdi for Sai Baba Darshan and other pilgrimage activities." 
        }, 
        { 
            question: "Can families book a taxi from Nashik Airport to Shirdi?", 
            answer: "Yes, families can select a suitable vehicle according to passenger count, luggage requirements, and preferred comfort level for the airport-to-Shirdi journey." 
        }, 
        { 
            question: "Do you provide one-way Nashik Airport to Shirdi Cab service?", 
            answer: "Yes, one-way cab service is available for passengers who need direct transportation from Nashik Airport to Shirdi without requiring the same vehicle for the return journey." 
        }, 
        { 
            question: "Can I book a return cab from Shirdi to Nashik Airport?", 
            answer: "Yes, return transportation can be discussed for passengers who need to travel from Shirdi back towards Nashik Airport after completing their pilgrimage or stay." 
        }, 
        { 
            question: "Which vehicles are available for Nashik Airport to Shirdi travel?", 
            answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and travel requirements." 
        }, 
        { 
            question: "Can I carry luggage from Nashik Airport to Shirdi?", 
            answer: "Yes, passengers can carry airport luggage according to the available storage capacity of the selected vehicle. Bulky or additional baggage should be mentioned during booking." 
        }, 
        { 
            question: "How can I book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs?", 
            answer: "Share your flight details, Nashik Airport arrival time, Shirdi destination, travel date, passenger information, luggage requirements, and preferred vehicle with Sai Shirdi Cabs to proceed with the cab booking." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Prakash Gaikwad", 
            feedback: "We landed at Nashik Airport and needed to continue to Shirdi with our family. The private cab was convenient because we could travel directly with our luggage and avoid changing vehicles.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Meena Joshi", 
            feedback: "Our Shirdi pilgrimage started after arriving at Nashik Airport. We booked a private taxi for the transfer and found it much easier to travel together with our parents and bags.", 
            rating: 5 
        } 
    ];




    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Nashik Airport to Shirdi Cab",
  "image": "https://www.saishirdicabs.com/assets/images/nashik-airport-to-shirdi-cab.webp",
  "description":
    "Book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs for safe, comfortable, and affordable airport transfer services. We provide reliable one-way and round-trip taxis from Nashik Airport to Shirdi with convenient pickup and drop facilities. Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller for Sai Baba Temple visits, family trips, pilgrimage journeys, Shirdi sightseeing, and nearby destinations with professional drivers and competitive fares.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/nashik-airport-to-shirdi-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Nashik Airport to Shirdi Cab | Nasik Airport Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Nashik Airport to Shirdi Cab with Sai Shirdi Cabs for affordable one-way and round-trip airport taxi services. Hire Sedan, Ertiga, Innova, Innova Crysta and Tempo Traveller from Nashik Airport to Shirdi with reliable pickup, professional drivers and comfortable travel."
  />

  <meta
    name="keywords"
    content="Nashik Airport to Shirdi Cab, Nasik Airport to Shirdi Taxi Fare, Nasik Airport to Shirdi Taxi, Nasik Airport Shirdi Taxi Fare, Best Taxi from Nasik Airport to Shirdi, Cheap Taxi Nasik Airport Shirdi, Book Taxi Nasik Airport to Shirdi, One-Way Taxi Nasik Airport Shirdi, Round Trip Taxi Nasik Airport Shirdi, Car Rental Nasik Airport to Shirdi, Reliable Taxi Nasik Airport to Shirdi, Nashik Airport to Shirdi Cab Service, Nashik Airport to Shirdi Taxi Service, Nashik Airport to Shirdi Cab Booking, Nashik Airport to Shirdi Taxi Booking, Nashik Airport to Shirdi One Way Cab, Nashik Airport to Shirdi Round Trip Cab, Nashik Airport to Shirdi Cab Fare, Nashik Airport to Shirdi Taxi Fare, Nashik Airport to Shirdi Airport Taxi, Nashik Airport Pickup to Shirdi, Nashik Airport Drop Taxi to Shirdi, Nashik Airport Shirdi Cab, Nashik Airport Shirdi Taxi, Nasik Airport Shirdi Cab, Nasik Airport Shirdi Taxi, Nashik Airport to Shirdi Online Cab Booking, Affordable Nashik Airport to Shirdi Cab, Best Nashik Airport to Shirdi Taxi, Cheap Nashik Airport to Shirdi Cab, Reliable Nashik Airport Taxi Service, Nashik Airport to Shirdi Sedan Cab, Nashik Airport to Shirdi Ertiga Cab, Nashik Airport to Shirdi Innova Cab, Nashik Airport to Shirdi Innova Crysta Cab, Nashik Airport to Shirdi Tempo Traveller, Nashik Airport to Shirdi Car Rental, Nashik Airport to Shirdi Car Hire, Nashik Airport to Shirdi Sai Baba Cab, Nashik Airport to Shirdi Pilgrimage Taxi, Nashik Airport to Shirdi Family Cab, Nashik Airport to Shirdi Transfer Service, Shirdi to Nashik Airport Cab, Shirdi to Nashik Airport Taxi, Shirdi to Nashik Airport One Way Cab, Shirdi to Nashik Airport Round Trip Taxi, Nashik Airport to Shani Shingnapur Cab, Nashik Airport to Shirdi Sightseeing Taxi, Nashik Airport to Shirdi Travel Service, Nashik Airport Shirdi Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Nashikairporttoshirdicab;